import { Grid } from "@mui/material";
import { useState } from "react";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Test, ItemContainerStyled, ItemImageContainerStyled, EnglishArabicFlexStyled, ItemDescriptionContainerStyled, ItemEnglishTitleStyled, PriceContainerStyled, ItemEnglishDescriptionStyled, ArabicContainerStyled, ItemArabicDescriptionStyled, ItemArabicTitleStyled} from "./generalStyles"
import dessert from "../../../data/ltbCategories/dessert";


function DessertGrid() {
          
    const [showDish, setShowDish] = useState(-1);
    function handleClick(id) {
        setShowDish(id);
    }

    if(showDish < 0) {
        return (
            <Grid container spacing = {1} rowSpacing = {0} paddingTop = {3} paddingBottom = {3} width = {"95%"}>
                <Grid item xs = {6} style = {{paddingTop: "2px"}}>
                    <div onClick = {() => handleClick("0")}>
                    <img style = {{width: "100%"}} src = "/blt-menu-designs/Dessert JPG/Grid JPG/Cream caramel Dessert.jpg"/>
                    <div className="dish-title">Vanilla Cream Caramel</div>
                    </div>
                </Grid>
                <Grid item xs = {6} style = {{paddingTop: "2px"}}>
                    <div id = "2" onClick = {() => handleClick("1")}>
                    <img style = {{width: "100%"}} src = "/blt-menu-designs/Dessert JPG/Grid JPG/Creme brulee Dessert.jpg"/>
                    <div className="dish-title">Cream Brulee</div>
                    </div>
                </Grid>
                <Grid item xs = {6} style = {{paddingTop: "2px"}}>
                    <div id = "3" onClick = {() => handleClick("2")}>
                    <img style = {{width: "100%"}} src = "/blt-menu-designs/Dessert JPG/Grid JPG/French toast Dessert.jpg"/>
                    <div className="dish-title">French Toast</div>
                    </div>
                </Grid>
                <Grid item xs = {6} style = {{paddingTop: "2px"}}>
                    <div id = "4" onClick = {() => handleClick("3")}>
                    <img style = {{width: "100%"}} src = "/blt-menu-designs/Dessert JPG/Grid JPG/CheeseCakeBB Dessert.jpg"/>
                    <div className="dish-title">Blueberry Cheesecake</div>
                    </div>
                </Grid>
                <Grid item xs = {6} style = {{paddingTop: "2px"}}>
                    <div id = "5" onClick = {() => handleClick("4")}>
                    <img style = {{width: "100%"}} src = "/blt-menu-designs/Dessert JPG/Grid JPG/CheeseCakeMango Dessert.jpg"/>
                    <div className="dish-title">Mango Cheesecake</div>
                    </div>
                </Grid>
            </Grid>
        )
    }

    if(showDish >= 0) {
        return (
            <Test>
            <div className = "dish-heading">
                Dessert
            </div>
            <ItemContainerStyled>
                    <ItemImageContainerStyled>
                        <img src = {dessert[showDish].img_src}/>
                    </ItemImageContainerStyled>
                    <EnglishArabicFlexStyled>
                        <ItemDescriptionContainerStyled>
                            <ItemEnglishTitleStyled>
                                {dessert[showDish].name_en}
                                <PriceContainerStyled>
                                    {dessert[showDish].price} <span>QR</span>
                                </PriceContainerStyled>
                            </ItemEnglishTitleStyled>
                            <ItemEnglishDescriptionStyled>
                                {dessert[showDish].description_en}
                            </ItemEnglishDescriptionStyled>
                            <ArabicContainerStyled>
                                <ItemArabicTitleStyled>
                                    {dessert[showDish].name_ar}
                                </ItemArabicTitleStyled>
                                <ItemArabicDescriptionStyled>
                                    {dessert[showDish].description_ar}
                                </ItemArabicDescriptionStyled>
                            </ArabicContainerStyled>
                        </ItemDescriptionContainerStyled>
                    </EnglishArabicFlexStyled>
                </ItemContainerStyled>
            <div className = "dish-close-icon" onClick ={()=>setShowDish(-1)}>
                <FontAwesomeIcon icon = {faXmark}/>
            </div>
        </Test>
        )
    }  
}


export default DessertGrid;